import React, { FC, useState } from 'react';
import ResultComponent from './ResultComponent';
import SearchComponent from './SearchComponent';

const AppComponent: FC = () => {
  const [search, setSearch] = useState<string>('');
  return (
    <>
      <SearchComponent setSearch={setSearch} />
      {
        search && (
          <ResultComponent search={search} />
        )
      }
    </>
  );
};

AppComponent.displayName = 'AppComponent';
export default AppComponent;
